<template>
    <div class="neopark-dis-parks">
        <div class="container">
            <div class="dis-parks-carousel" v-if="!isMobileChecker">
                <swiper :options="swiperOption" ref="landNeoParkParksCarousel">
                    <swiper-slide v-for="(slide, index) in salesCard.neopark_land_parks.cards" :key="index">
                        <div class="slide-content-container">
                            <div class="slide-content" :class="{'first' : index == 0}">
                                <strong v-html="slide.title"></strong>
                                <div class="slide-desc" v-html="slide.desc"></div>
                                <div class="slide-icons-list">
                                    <div class="list-item" v-for="list in slide.icon_list">
                                        <div class="icon-img"><img :src="list.icon" alt=""></div>
                                        <p v-html="list.desc"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="promo-pic" :style="'background-image: url(' + slide.img + ')'"></div>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-controls neo-dis-controls">
                    <div class="sales-land-btn-prev neo-dis-btn-prev slider-btn">
                        <svgIcon name="left-arrow-neo" />
                    </div>
                    <div class="sales-land-btn-next neo-dis-btn-next slider-btn">
                        <svgIcon name="right-arrow-neo" />
                    </div>
                </div>
            </div>
            <div class="dis-parks-cards-mobile" v-if="isMobileChecker">
                <div class="p-card-items" v-for="(slide, index) in salesCard.neopark_land_parks.cards" :key="index"  :class="{'first' : index == 0}">
                        <strong v-html="slide.title"></strong>
                        <div class="slide-desc" v-html="slide.desc"></div>
                        <div class="slide-icons-list">
                            <div class="list-item" v-for="list in slide.icon_list">
                                <div class="icon-img"><img :src="list.icon" alt=""></div>
                                <p v-html="list.desc"></p>
                            </div>
                        </div>
                        <div class="promo-pic" :style="'background-image: url(' + slide.img + ')'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    export default {
        name: 'neopark-dis-parks',
        components: {
            svgIcon,
        },
        data () {
            return {
                projectNameG: window.host,
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    // autoplay: {
                    //     delay: 3500,
                    //     disableOnInteraction: true,
                    // },
                    navigation: {
                        nextEl: '.neo-dis-btn-prev',
                        prevEl: '.neo-dis-btn-next',
                    },
                    // pagination: {
                    //     el: '.sales-land-lobbi-pagination',
                    //     type: 'bullets',
                    //     clickable: true,
                    // },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/neopark/dis-parks.scss';
    @import '@/styles/components/sales/sales-land-partials/neopark/respond/dis-parks-respond.scss';
    // @import '@/styles/components/sales/respond/land-about-respond.scss';
</style>